// extracted by mini-css-extract-plugin
module.exports = {"templateParagraph":"TemplateParagraph_templateParagraph__2oY6Y","italic":"TemplateParagraph_italic__jRzPs"};